import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Sidebar from "@/layout/Sidebar";
import TopNavbar from "@/layout/TopNavbar";
import "./page.css";

function NotFound() {
  const { t } = useTranslation();
  const [isPermanentlyExpanded, setIsPermanentlyExpanded] = useState(true);

  const toggleSidebar = () => {
    setIsPermanentlyExpanded(!isPermanentlyExpanded);
  };

  return (
    <div className="app-container">
      <Sidebar
        currentPage={"Not Found"}
        isPermanentlyExpanded={isPermanentlyExpanded}
      />
      <main className="content">
        <div className="container-fluid p-4">
          <TopNavbar
            isPermanentlyExpanded={isPermanentlyExpanded}
            toggleSidebar={toggleSidebar}
          />
          <h1>{t("notFound.title", "Page Not Found")}</h1>
          <p>{t("notFound.message", "The page you are looking for does not exist.")}</p>
        </div>
      </main>
    </div>
  );
}

export default NotFound;
